import React from 'react';
import './SignupModal.css';

interface SignupModalProps {
  isOpen: boolean;
  userData: {
    email: string;
    name: string;
    profile_picture?: string;
    google_id: string;
  };
  onConfirm: () => void;
  onCancel: () => void;
}

const SignupModal: React.FC<SignupModalProps> = ({ isOpen, userData, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div className="signup-overlay">
      <div className="signup-modal">
        <h2>회원가입 확인</h2>
        <p>다음 정보로 AWS Exam Practice에 가입하시겠습니까?</p>
        
        <div className="user-info-preview">
          {userData.profile_picture && (
            <img src={userData.profile_picture} alt="프로필" className="profile-preview" />
          )}
          <div className="info-details">
            <div className="signup-info-item">
              <strong>이름:</strong> {userData.name}
            </div>
            <div className="signup-info-item">
              <strong>이메일:</strong> {userData.email}
            </div>
          </div>
        </div>
        
        <div className="modal-buttons">
          <button className="signup-cancel-button" onClick={onCancel}>
            취소
          </button>
          <button className="confirm-button" onClick={onConfirm}>
            가입하기
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignupModal;